import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../configurations/axiosInstance/AxiosInstance";
import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Col, DatePicker, Empty, Form, Input, message, Modal, Row, Select, Space, Spin, Tag } from "antd";
import { useSelector } from "react-redux";
import BreadCom from "../../../components/breadCom/BreadCom";
import { useRole, useTitle } from "../../../configurations/utils/Utils";
import Loader from "../../../composants/loader/Loader";
import * as Utils from '../../../composants/utils/utils';
import { FormattedMessage } from "react-intl";

export default function UpdateGallery({ gallery }) {
    useRole([Utils.PERMISSIONS.UPDATE_SLIDER.value]);
    const { accessToken } = useSelector(state => state.authUser);
    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [form] = Form.useForm();
    const [selectedValue, setSelectedValue] = useState(null);
    const openModal = () => {
        form.resetFields();
        setLoading(false);
        setModalAddOpen(true);
    }
    const handleSelectChange = (value) => {
        setSelectedValue(value);
    };
    const onSubmit = (values) => {
        setLoading(true);
        const dat = {
            id: gallery.id,
            title: values.title,
            description: values.description,
            duree: gallery.type === 'IMAGE' ? null : values.duree,
        };
        axiosInstance(accessToken).put(
            "api/gallery/update/" + gallery.id,
            dat
        ).then(
            (result) => {
                message.success('Gallery file updated');
                setTimeout(
                    () => {
                        form.resetFields();
                        setLoading(false);
                        window.location.reload();
                        setModalAddOpen(false);
                    }, 2000
                )
            }).catch((error) => {
                setLoading(false);
                message.error(error.response.data.error);
            });
    };

    return (
        <>
            <Button style={{ float: "right" }} onClick={openModal} >
                <i className="fa fa-edit" aria-hidden="true"></i>Modifier
            </Button>
            <Modal
                title="Modification"
                style={{
                    top: 20,
                }}
                width={1000}
                open={modalAddOpen}
                maskClosable={false}
                closable={false}
                footer={[]}
            >
                <Spin spinning={loading}>
                    <Form onFinish={onSubmit} form={form} initialValues={gallery}>
                        <Form.Item
                            label="Title"
                            name="title"
                            rules={
                                [
                                    { required: true, message: 'Veuillez entrer le titre' },
                                    { type: "string", message: "Entrer un nom valide !" }
                                ]}
                            hasFeedback>
                            <Input placeholder="entrer le Titre" />
                        </Form.Item>

                        <Form.Item
                            label="description"
                            name="description">
                            <Input.TextArea placeholder="Veuillez entrer la description" maxLength={255} showCount />
                        </Form.Item>

                        {(gallery.type === 'VIDEO' || gallery.type === 'AUDIO') && (
                            <Form.Item
                                label={<FormattedMessage id="duree" />}
                                name="duree"
                                rules={[{ required: true, message: 'Veuillez entrer la durée' }]}
                            >
                                <Input type="number" min={1} placeholder="Durée en secondes" />
                            </Form.Item>
                        )}
                        <Form.Item>
                            <Space style={{ float: 'right' }}>
                                <Button type='primary' htmlType='submit' disabled={loading}>
                                    Submit
                                </Button>
                                <Button danger disabled={loading} onClick={() => setModalAddOpen(false)} >
                                    <i className="fa fa-times" aria-hidden="true"></i> cancel
                                </Button>

                            </Space>
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
}